module.exports = __webpack_public_path__ + "img/nykaa_fashion.860aeea5.svg";